import { setSaveStatusBasedOnApiResponse } from '../grid/reduxStore/saveStatusSlice';
import { updateGridLayerConfig } from '../grid/reduxStore/editorSlice';
import type { BlockCommandDependencies } from './BlockBaseCommand.ts';
import { BlockBaseCommand } from './BlockBaseCommand.ts';
import { updateBlockLayerViaSocket } from '../grid/reduxStore/saveHandlers.ts';

type LayerTransaction = {
  blockId: string;
  previousZIndex: number;
  newZIndex: number;
};

export class UpdateBlockLayerCommand extends BlockBaseCommand {
  readonly sectionId: string;
  private readonly transactions: LayerTransaction[];

  constructor(sectionId: string, transactions: LayerTransaction[], dependencies: BlockCommandDependencies) {
    super(dependencies);
    this.sectionId = sectionId;
    this.transactions = transactions;
  }

  async undo(): Promise<boolean> {
    return this.applyLayers(
      this.transactions.map((t) => ({
        blockId: t.blockId,
        zIndex: t.previousZIndex,
      }))
    );
  }

  async redo(): Promise<boolean> {
    return this.applyLayers(
      this.transactions.map((t) => ({
        blockId: t.blockId,
        zIndex: t.newZIndex,
      }))
    );
  }

  private async applyLayers(changes: { blockId: string; zIndex: number }[]): Promise<boolean> {
    try {
      this.setSaving();

      for (const { blockId, zIndex } of changes) {
        const response = await updateBlockLayerViaSocket(this.socketClient, {
          blockId,
          userId: this.userId,
          zIndex,
        });

        if (this.checkDocumentLockStatus(response.errorCode)) {
          this.setNotSaved();
          return false;
        }

        this.dispatch(
          updateGridLayerConfig({
            sectionId: this.sectionId,
            blockId,
            zIndex,
          })
        );

        this.dispatch(setSaveStatusBasedOnApiResponse(response));
      }

      return true;
    } catch (error) {
      console.error('Failed to apply layer changes:', error);
      this.setNotSaved();
      return false;
    }
  }

  getCurrentBlockId(): string {
    return this.transactions[0]?.blockId ?? '';
  }
}
